import { render, staticRenderFns } from "./editOthers.vue?vue&type=template&id=2cd417f6&scoped=true"
import script from "./editOthers.vue?vue&type=script&lang=ts"
export * from "./editOthers.vue?vue&type=script&lang=ts"
import style0 from "./editOthers.vue?vue&type=style&index=0&id=2cd417f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd417f6",
  null
  
)

export default component.exports